import { render, staticRenderFns } from "./Participations.vue?vue&type=template&id=fa388e8a&"
import script from "./Participations.vue?vue&type=script&lang=js&"
export * from "./Participations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports